import { Table } from "antd";
import React from "react";
import "../../global-styles/table-style.scss";

const ProjectInformation = ({ projectInfo }) => {
  // Dynamically generate tableData from projectInfo
  let tableData = [];
  if (projectInfo && projectInfo.values) {
    let keyCounter = 1;
    Object.entries(projectInfo.values).forEach(([sectionName, fields]) => {
      // Add section header
      tableData.push({
        key: keyCounter++,
        parameter: sectionName,
        value: "",
        isHeader: true,
      });
      // Add each field in the section
      Object.values(fields).forEach((field) => {
        tableData.push({
          key: keyCounter++,
          parameter: field.text || field.internalName,
          value:
            field.value !== undefined && field.value !== null
              ? field.value
              : "",
        });
      });
    });
  }

  const columns = [
    {
      title: "",
      dataIndex: "parameter",
      key: "parameter",
      width: "60%",
      render: (text, record) => {
        if (record.isHeader) {
          return <span style={{ color: "#e03540" }}>{text}</span>;
        }
        return text;
      },
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 2 };
        }
        return {};
      },
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      width: "40%",
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <div
      className="project-info-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        bordered={false}
        className="welding-parameters-table"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default ProjectInformation;
